export const envConfigForShare = {
  prod: {
    policyServiceUrl: 'https://health-policy-service.internal.live.acko.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-service.internal.ackolife.com/life/api/v1/proposals',
  },
  master: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
  },
  dev: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
  },
  local: {
    policyServiceUrl: 'https://health-policy-service-uat.internal.ackodev.com/health/policy-details',
    proposalServiceUrl: 'https://life-proposal-builder.internal.ackodev.com/life/api/v1/proposals',
  },
}
